import { useEffect } from "react"

import Users from "../PersonalSettings/Users"

import "./styles.less"

const TeamPage = () => {
  useEffect(() => {
    document.title = "Team - Chargeback"
  }, [])

  return (
    <div className="team-page">
      <Users isTeamPage />
    </div>
  )
}

export default TeamPage
